// extracted by mini-css-extract-plugin
export default {"selector":"r0Lwo","icon":"_dBT2","selectorOptions":"hQy2p","selectorOption":"s0GVv","employeeEdit":"xxtuy"};